import React, {Component} from 'react';
import MetaTags from 'react-meta-tags';

// Containers
import ContentHeader from '../../containers/ContentHeader/ContentHeader';

// Components
import Button from '../../components/Button/Button'
import RandomReview from '../../components/RandomReview/RandomReview';
import Anime from '../../components/Anime/Anime';

class PageAbout extends Component {


    render () {
         return (
            <div className="app-section">
                <MetaTags>
                    <title>About Us</title>
                    <meta 
                        name="description" 
                        content="We offer a variety creatve WordPress themes. We are specialized in producing unique WordPress themes with the perfect balance between coding and design. We offer a variety of themes for creative artists such as musicians, photographers, film makers." 
                    />
                </MetaTags>

                <div className="container">
                    <ContentHeader 
                        title="About us" 
                        subTitle="" 
                        classes="" 
                    />

                    <div className="row row-large-gutter">
                        <div className="col-lg-7 col-md-6 col-12 mb mb-sm">
                        	<Anime type="fade-up" delay="3" duration="3">
	                            <h2>A Brief History</h2>
	                            <p>Making themes was our hobby at first. Rascals Themes officially founded in July, 2010 is powered by a small team of designers and developers. Our crew has been specializing in website design and development from over 7 years and we are proud that 14 000 people use Rascals Themes every day. We love <i className="pe-icon pe-7s-like"></i> WordPress because it’s a dream platform—versatile, powerful and incredibly intuitive.
	                            </p>
	                            <p><Button title="View WordPress Themes" link="/themes" icon="line-arrow-right" classes="big shadow arrow-anim" /> </p>
                            </Anime>

                        </div>

                        <div className="col-lg-5 col-md-6 col-12 mb mb-sm">
	                        <Anime type="fade-up" delay="4" duration="3">
	                            <h2>Our Philosophy</h2>
	                            <p>Our goal is to produce unique WordPress themes with the perfect balance between coding and design. We offer a variety of themes for creative artists such as musicians, photographers, film makers.. We create totally new Premium Wordpress Themes that are not available anywhere else. We continue to develop new themes and updating existing with new features and improvements.</p>
	                        </Anime>
                        </div>

                    </div>
                </div>
                <RandomReview classes="random-review--full-color pt2 pb2" />
            </div>
        );
    }
}

export default PageAbout;


// WEBPACK FOOTER //
// ./src/pages/PageAbout/PageAbout.js